module.exports = "<nav class=\"nav cardtabs flex-column\">\n  <a [routerLink]=\"[menuItem.path]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact:\n      true}\" class=\"nav-link {{menuItem.class}}\"\n    *ngFor=\"let menuItem of menuItems\">{{menuItem.title}}</a>\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cardtabs/cardtabs.component.html
// module id = ./src/app/components/cardtabs/cardtabs.component.html
// module chunks = main